import { ContestType } from '@betterpool/api-types/contests-service';

import type { FullContestTeamSurvivor } from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import type { ContestSlate } from '~/domains/games/interfaces/contest.slates.interface';

import type { SlateWithStateAndSettingsTeam } from '../../team/parsers/parseSlateTeamBase/parseSlateTeamBase';
import parseSlateTeamBase from '../../team/parsers/parseSlateTeamBase/parseSlateTeamBase';

type SlateWithStateAndSettingsTeamSurvivor = SlateWithStateAndSettingsTeam;

const parseTeamSurvivorSlates = (
  contest: FullContestTeamSurvivor,
  slates: ContestSlate[]
): SlateWithStateAndSettingsTeamSurvivor[] =>
  slates.map((slate, index) => ({
    contestType: ContestType.TEAM_PICK_EM,
    ...parseSlateTeamBase(contest, slate, index),
  }));

export default parseTeamSurvivorSlates;

export type { SlateWithStateAndSettingsTeamSurvivor };
